import { ProductProps } from '@/interfaces/models/product';
import Product from '@/models/product';

export default () => {
  if (Array.isArray(window.axios.defaults.transformResponse)) {
    return window.axios.defaults.transformResponse.concat((productsProps: ProductProps[]): Product[] => {
      return productsProps.map(Product.createFromRequest);
    });
  }
};
